import { IKeyFeatures } from "@components/projects/level01/level01.state";
import { FC } from "react";
import styles from "./key-features.module.scss";
import Image from "next/image";
import Level01Animation from '@components/projects/level01/animations';
import animations from '@components/projects/level01/animations/animations.module.scss';

interface KeyFeaturesSectionProps {
  section: IKeyFeatures;
}

const KeyFeaturesSection: FC<KeyFeaturesSectionProps> = ({ section }) => {
  return (
    <section className={`${styles.section}`}>
        <Level01Animation render={(ref) => (
          <div ref={ref} className={`${styles.section__head} ${animations.scroll__animation}`}>
          <h2 className={styles.section__title}>{section.title}</h2>
          <p className={styles.section__subtitle}>{section.subtitle}</p>
        </div>
        )}/>
        {section.blocks.map((block, idx) => {
          const reversed: boolean = idx % 2 !== 0;
          const classes: string = `${styles.section__block} ${reversed ? styles.reversed : ""} ${animations.scroll__animation}`;

          return (
            <Level01Animation key={block.imageUrl} render={(ref) => (
              <div ref={ref} className={classes}>
                <div className={styles.section__block_content}>
                  {block.points.map((item) => (
                    <div className={styles.section__block_item} key={item.pointNumber}>
                      <div className={styles.section__block_head}>
                        <div className={styles.section__block_point}>{item.pointNumber}</div>
                        <h3 className={styles.section__block_title}>{item.title}</h3>
                      </div>
                      <p className={styles.section__block_description}>{item.content}</p>
                    </div>
                  ))}
                </div>
                <div className={styles.section__block_img}>
                  <div className={styles.section__block_img_container}>
                    <Image src={block.imageUrl} alt={section.title} layout={"fill"} />
                  </div>
                </div>
              </div>
            )}/>
          );
        })}
      </section>
  );
};

export default KeyFeaturesSection;
